import styled from "styled-components";

//color control
const baseShareColor = 'rgb(200,200,200)';
//animate control
const baseShareBoxShadow = '1.5px 1.5px 2px 0px #000000';
const baseShareBoxShadowHover = '2.5px 2.5px 5px 0px #000000';
const baseShareBoxShadowActive = '0px 0px 0px 0px #000000';

export const ShareDiv = styled.div`
    display: flex;
    position: fixed;
    top: 30%;
    right:${props => (props.share ? '-10px' : '-60px')};
    width: 80px;
    padding: 10x 10px 10px 10px;
    border-radius: 5px;
    background: ${props => (props.share ? 'white' : baseShareColor)};
    /*CSS animate*/
    -webkit-box-shadow: ${baseShareBoxShadow};
            box-shadow: ${baseShareBoxShadow};
    -webkit-transition: 0.2s all ease-out;
        -o-transition: 0.2s all ease-out;
            transition: 0.2s all ease-out;
    :hover {
    -webkit-box-shadow: ${props => (props.share ? null : baseShareBoxShadowHover)};
            box-shadow: ${props => (props.share ? null : baseShareBoxShadowHover)};
    }
    :active {
    -webkit-box-shadow: ${props => (props.share ? null : baseShareBoxShadowActive)};
            box-shadow: ${props => (props.share ? null : baseShareBoxShadowActive)};
    }
    :focus {
        outline:0;
    }
    @media screen and (max-height: 600px) {
        top:10%;
        right:${props => (props.share ? '-10px' : '-160px')};
        width:180px;
      }
    z-index:500;
    cursor: pointer;
`;
